"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.root = void 0;

var _emotion = require("emotion");

var root = function root(theme, disabled) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("color:", theme.color.dark.amethyst, ";fill:", theme.color.dark.amethyst, ";font-size:14px;font-weight:500;letter-spacing:0.18px;border:none;outline:none;background:none;position:relative;padding:0px;display:inline-flex;align-items:center;svg{height:14px;width:14px;}opacity:", disabled ? 0.5 : 1, ";transition:all 0.3s;cursor:", disabled ? 'not-allowed' : 'pointer', ";")
  );
};

exports.root = root;